import React from 'react';
import './nfdColorsSection.scss';
import NfdColorsItemComponent from "./components/NfdColorsItemComponent";
import NfdColorsCustomItemComponent from "./components/NfdColorsCustomItemComponent";

const NfdColorsSection = () => {
	return (
		<div className="nfdColors">
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="nfdColors__content">
				<div className="nfdColors__content_title">
					<h2>NFD Colors</h2>
				</div>
				
				<div className="nfdColors__content_data">
					<div className="nfdColors__content_data_row first">
						<div className="stars"></div>
						<div className="stars2"></div>
						<div className="stars3"></div>
						<NfdColorsItemComponent color={'dark'} colorCode={'#080015'} />
						<NfdColorsItemComponent color={'gray'} colorCode={'#ABAAB7'} />
						<NfdColorsItemComponent color={'white'} colorCode={'#FFFFFF'} />
					</div>
					<div className="nfdColors__content_data_row second">
						<div className="stars"></div>
						<div className="stars2"></div>
						<div className="stars3"></div>
						<NfdColorsItemComponent color={'pink'} colorCode={'#D6B0FF'} />
						<NfdColorsItemComponent color={'purple 1'} colorCode={'#5E41CE'} />
						<NfdColorsItemComponent color={'purple 2'} colorCode={'#7551FF'} />
						<NfdColorsItemComponent color={'blue'} colorCode={'#007AFF'} />
					</div>
					<div className="nfdColors__content_data_row third">
						<div className="stars"></div>
						<div className="stars2"></div>
						<div className="stars3"></div>
						<NfdColorsCustomItemComponent color={'gradient 1'} colorCodes={['#D6B0FF', '#A08AFF']} />
						<NfdColorsCustomItemComponent color={'gradient 2'} colorCodes={['#A18BF5', '#5E41CE', '#190C4A']} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default NfdColorsSection;